module.exports = __webpack_public_path__ + "img/businessTag.8d6d7c54.png";